import { FC, useEffect, useState } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import { Card, Col, Image, Row, SimpleCollapse, Span } from 'components'
import { PERMITIONS } from 'components/DrawerMenu/routes_list'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useAuth, useLoading, useModal, useReportPrint } from 'hooks'
import {
  IHandlePrintConsolidacaoEfetivo,
  IRelatorioTurnOverContent
} from 'hooks/useReportPrint/types'
import {
  EffectiveConsolidationServices,
  ITotalizadoresAndItensTurnOverContent,
  ITurnOver,
  ITurnOverTable
} from 'services/NGT/EffectiveConsolidation'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

import { downloadURI } from '../../EffectiveConsolidation'
import { ReportTable } from './components/ReportTable/ReportTable'
import { FormatTableData } from './ultils/FormatTableData'

interface ICollapsesPropsPDF {
  collapseTitle: string
  tableTitle: string
}

interface IReportTurnOver {
  flRecorrente: boolean
}

const ReportTurnOver: FC<IReportTurnOver> = ({ flRecorrente }) => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()
  const { user } = useAuth()
  const { handlePrintTurnOver } = useReportPrint()

  const [isGeneratePDF, setIsGeneratePDF] = useState<boolean>(false)
  const [reportTurnOverByArea, setReportTurnOverByArea] = useState<ITurnOverTable>()
  const [reportTurnOverByCompany, setReportTurnOverByCompany] = useState<ITurnOverTable>()
  const [reportTurnOverByExecutive, setReportTurnOverByExecutive] = useState<ITurnOverTable>()
  const [reportTurnOverByUnit, setReportTurnOverByUnit] = useState<ITurnOverTable>()

  const collapsesTitles: ICollapsesPropsPDF[] = [
    {
      collapseTitle: 'Distribuição por Diretoria Executiva',
      tableTitle: 'Diretoria Executiva'
    },
    {
      collapseTitle: 'Distribuição por Empresas',
      tableTitle: 'Empresa'
    },
    {
      collapseTitle: 'Distribuição por Área',
      tableTitle: 'Área'
    },
    {
      collapseTitle: 'Distribuição por Unidade de Negócio',
      tableTitle: 'Unidade Negócio'
    }
  ]

  const GenerateExcelTurnOver = async () => {
    setLoading('loading')

    EffectiveConsolidationServices()
      .GetExcelTurnOver(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )
      .then((response) => {
        if (response.status === 200) {
          downloadURI(response.data, `Relatorio-Turn_Over.xlsx`)
        }
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem ||
            error.message ||
            'Não foi possivel fazer o download da planilha, tente novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleClickPdfReport = async () => {
    setLoading('loading')

    try {
      setLoading('idle')

      const pdfDataArray: IRelatorioTurnOverContent[] = []

      collapsesTitles.forEach((collapseTitle) => {
      formatTurnOverArray(reportTurnOverByExecutive, reportTurnOverByCompany, reportTurnOverByArea, reportTurnOverByUnit)

        pdfDataArray.push({
          body:
            collapseTitle.collapseTitle ===
              'Distribuição por Diretoria Executiva'
              ? reportTurnOverByExecutive?.itensConsolidacao.map((item, index) => {
                const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                // Criando as listas principais
                effectiveByExecutiveArray.push([
                  item?.totalizadores?.dsConsolidacao.toUpperCase(),
                  item?.totalizadores.ativo,
                  item?.totalizadores.demitido,
                  item?.totalizadores.acesso,
                  item?.totalizadores.transferido,
                  item?.totalizadores.afastado,
                  item?.totalizadores.compartilhado,
                  item?.totalizadores.totalEfetivo,
                  item?.totalizadores.qtTotalSemDemitido,
                  item?.totalizadores.turnOver + '%'
                ])
                // Adicionando as listas de subItens
                item.itens.forEach(
                  (subItem: ITotalizadoresAndItensTurnOverContent) =>
                    effectiveByExecutiveArray.push([
                      FORMAT.capitalizeString(
                        subItem?.dsConsolidacao.toLowerCase()
                      ),
                      subItem?.ativo,
                      subItem?.demitido,
                      subItem?.acesso,
                      subItem?.transferido,
                      subItem?.afastado,
                      subItem?.compartilhado,
                      subItem?.totalEfetivo,
                      subItem?.qtTotalSemDemitido,
                      subItem?.turnOver + '%'
                    ])
                )
                !reportTurnOverByExecutive.itensConsolidacao[index + 1] && effectiveByExecutiveArray.push([
                  "Total",
                  reportTurnOverByExecutive?.total?.ativo,
                  reportTurnOverByExecutive?.total?.demitido,
                  reportTurnOverByExecutive?.total?.acesso,
                  reportTurnOverByExecutive?.total?.transferido,
                  reportTurnOverByExecutive?.total?.afastado,
                  reportTurnOverByExecutive?.total?.compartilhado,
                  reportTurnOverByExecutive?.total?.totalEfetivo,
                  reportTurnOverByExecutive?.total?.qtTotalSemDemitido,
                  reportTurnOverByExecutive?.total?.turnOver + '%',
                ])
                return effectiveByExecutiveArray
              })
              : collapseTitle.collapseTitle === 'Distribuição por Empresas'
                ? reportTurnOverByCompany.itensConsolidacao.map((item: ITurnOver, index) => {
                  const effectiveByCompanyArray: (string | number)[][] = [] // Array auxiliar
                  // Criando as listas principais
                  effectiveByCompanyArray.push([
                    item?.totalizadores?.dsConsolidacao.toUpperCase(),
                    item?.totalizadores.ativo,
                    item?.totalizadores.demitido,
                    item?.totalizadores.acesso,
                    item?.totalizadores.transferido,
                    item?.totalizadores.afastado,
                    item?.totalizadores.compartilhado,
                    item?.totalizadores.totalEfetivo,
                    item?.totalizadores.qtTotalSemDemitido,
                    item?.totalizadores.turnOver
                  ])
                  // Adicionando as listas de subItens
                  item.itens.forEach(
                    (subItem: ITotalizadoresAndItensTurnOverContent) =>
                      effectiveByCompanyArray.push([
                        FORMAT.capitalizeString(
                          subItem?.dsConsolidacao.toLowerCase()
                        ),
                        subItem?.ativo,
                        subItem?.demitido,
                        subItem?.acesso,
                        subItem?.transferido,
                        subItem?.afastado,
                        subItem?.compartilhado,
                        subItem?.totalEfetivo,
                        subItem?.qtTotalSemDemitido,
                        subItem?.turnOver + '%'
                      ])
                  )
                  !reportTurnOverByCompany.itensConsolidacao[index + 1] && effectiveByCompanyArray.push([
                    "Total",
                    reportTurnOverByCompany?.total?.ativo,
                    reportTurnOverByCompany?.total?.demitido,
                    reportTurnOverByCompany?.total?.acesso,
                    reportTurnOverByCompany?.total?.transferido,
                    reportTurnOverByCompany?.total?.afastado,
                    reportTurnOverByCompany?.total?.compartilhado,
                    reportTurnOverByCompany?.total?.totalEfetivo,
                    reportTurnOverByCompany?.total?.qtTotalSemDemitido,
                    reportTurnOverByCompany?.total?.turnOver + '%',
                  ])
                  return effectiveByCompanyArray
                })
                : collapseTitle.collapseTitle === 'Distribuição por Área'
                  ? reportTurnOverByArea.itensConsolidacao.map((item: ITurnOver, index) => {
                    const effectiveByAreaArray: (string | number)[][] = [] // Array auxiliar
                    // Criando as listas principais
                    effectiveByAreaArray.push([
                      item?.totalizadores?.dsConsolidacao.toUpperCase(),
                      item?.totalizadores.ativo,
                      item?.totalizadores.demitido,
                      item?.totalizadores.acesso,
                      item?.totalizadores.transferido,
                      item?.totalizadores.afastado,
                      item?.totalizadores.compartilhado,
                      item?.totalizadores.totalEfetivo,
                      item?.totalizadores.qtTotalSemDemitido,
                      item?.totalizadores.turnOver + '%'
                    ])
                    // Adicionando as listas de subItens
                    item.itens.forEach(
                      (subItem: ITotalizadoresAndItensTurnOverContent) =>
                        effectiveByAreaArray.push([
                          FORMAT.capitalizeString(
                            subItem?.dsConsolidacao.toLowerCase()
                          ),
                          subItem?.ativo,
                          subItem?.demitido,
                          subItem?.acesso,
                          subItem?.transferido,
                          subItem?.afastado,
                          subItem?.compartilhado,
                          subItem?.totalEfetivo,
                          subItem?.qtTotalSemDemitido,
                          subItem?.turnOver + '%'
                        ])
                    )
                    !reportTurnOverByArea.itensConsolidacao[index + 1] && effectiveByAreaArray.push([
                      "Total",
                      reportTurnOverByArea?.total?.ativo,
                      reportTurnOverByArea?.total?.demitido,
                      reportTurnOverByArea?.total?.acesso,
                      reportTurnOverByArea?.total?.transferido,
                      reportTurnOverByArea?.total?.afastado,
                      reportTurnOverByArea?.total?.compartilhado,
                      reportTurnOverByArea?.total?.totalEfetivo,
                      reportTurnOverByArea?.total?.qtTotalSemDemitido,
                      reportTurnOverByArea?.total?.turnOver + '%',
                    ])
                    return effectiveByAreaArray
                  })
                  : collapseTitle.collapseTitle ===
                    'Distribuição por Unidade de Negócio'
                    ? reportTurnOverByUnit.itensConsolidacao.map((item: ITurnOver, index) => {
                      const effectiveByUnitArray: (string | number)[][] = [] // Array auxiliar
                      // Criando as listas principais
                      effectiveByUnitArray.push([
                        item?.totalizadores?.dsConsolidacao.toUpperCase(),
                        item?.totalizadores.ativo,
                        item?.totalizadores.demitido,
                        item?.totalizadores.acesso,
                        item?.totalizadores.transferido,
                        item?.totalizadores.afastado,
                        item?.totalizadores.compartilhado,
                        item?.totalizadores.totalEfetivo,
                        item?.totalizadores.qtTotalSemDemitido,
                        item?.totalizadores.turnOver + '%'
                      ])
                      // Adicionando as listas de subItens
                      item.itens.forEach(
                        (subItem: ITotalizadoresAndItensTurnOverContent) =>
                          effectiveByUnitArray.push([
                            FORMAT.capitalizeString(
                              subItem?.dsConsolidacao.toLowerCase()
                            ),
                            subItem?.ativo,
                            subItem?.demitido,
                            subItem?.acesso,
                            subItem?.transferido,
                            subItem?.afastado,
                            subItem?.compartilhado,
                            subItem?.totalEfetivo,
                            subItem?.qtTotalSemDemitido,
                            subItem?.turnOver + '%'
                          ])
                      )
                      !reportTurnOverByUnit.itensConsolidacao[index + 1] && effectiveByUnitArray.push([
                        "Total",
                        reportTurnOverByUnit?.total?.ativo,
                        reportTurnOverByUnit?.total?.demitido,
                        reportTurnOverByUnit?.total?.acesso,
                        reportTurnOverByUnit?.total?.transferido,
                        reportTurnOverByUnit?.total?.afastado,
                        reportTurnOverByUnit?.total?.compartilhado,
                        reportTurnOverByUnit?.total?.totalEfetivo,
                        reportTurnOverByUnit?.total?.qtTotalSemDemitido,
                        reportTurnOverByUnit?.total?.turnOver + '%',
                      ])
                      return effectiveByUnitArray
                    })
                    : [],
          tableTitle: collapseTitle.tableTitle,
          titleCollapse: collapseTitle.collapseTitle
        })
      })

      if (pdfDataArray) {
        const pdfObject: IHandlePrintConsolidacaoEfetivo = {
          data: pdfDataArray,
          filename: `relatorio-consolidacao-turn-over`
        }
        handlePrintTurnOver(pdfObject)
      } else {
        showModal({
          hideButtonCancel: true,
          message: 'Não há efetivo cadastrado para este contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      }
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          error.mensagem ||
          error.message ||
          'Não foi possivel obter a lista de Efetivos deste contrato',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  const HeaderEffectiveConsolidationTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
        <Col justifyContent="center" marginLeft={SPACING.spacing200}>
          <Span
            text="RELATÓRIO  TURNOVER"
            color={COLORS.blueFonts}
            fontSize="24px"
            fontWeight={FONTS.bold}
            textTransform="uppercase"
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          />
          <Span
            textAlign="center"
            fontWeight="bold"
            fontSize={TYPOGRAPHY.bodySize16}
            color={COLORS.blueFonts}
            text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
            marginTop={SPACING.spacing15}
            marginBottom={SPACING.spacing15}
          />
        </Col>
      </Row>
    </Card>
  )

  const getReportTurnOver = async () => {
    setLoading('loading')
    try {
      const response = await EffectiveConsolidationServices().GetTurnOver(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )

      if (response.status !== 200) throw new Error(response.statusText)

      setReportTurnOverByArea(response.data.entity.area)
      setReportTurnOverByCompany(response.data.entity.empresa)
      setReportTurnOverByExecutive(response.data.entity.diretoriaExecutiva)
      setReportTurnOverByUnit(response.data.entity.unidadeNegocio)

      setLoading('idle')
    } catch (error: any) {
      setMsgErro('Erro ao carregar dados do relatório, tente novamente!')
      setLoading('error')
    }
  }

  useEffect(() => {
    getReportTurnOver()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <div id="pdfView">
        {isGeneratePDF ? (
          <HeaderEffectiveConsolidationTitle />
        ) : (
          <>
            <Row
              justifyContent="center"
              marginTop={SPACING.spacing15}
              marginBottom={SPACING.spacing5}
            >
              <Span
                textAlign="center"
                fontWeight="bold"
                fontSize={TYPOGRAPHY.bodySize16}
                color={COLORS.blueFonts}
                text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
                marginTop={SPACING.spacing15}
                marginBottom={SPACING.spacing5}
              />
            </Row>
            <Row justifyContent="flex-end">
              <ExcelIcon onClick={() => GenerateExcelTurnOver()} />
              <PdfIcon onClick={() => handleClickPdfReport()} />
            </Row>
          </>
        )}
        <Row marginBottom={SPACING.spacing30} />
        <SimpleCollapse
          title="Distribuição por Diretoria Executiva"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportTurnOverByExecutive}
            titleHeader="Diretoria Executiva"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Empresas"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportTurnOverByCompany}
            titleHeader="Empresa"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Área"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportTurnOverByArea}
            titleHeader="Área"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Unidade de Negócio"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportTurnOverByUnit}
            titleHeader="Unidade Negócio"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>
      </div>
    </Card>
  )
}

export default ReportTurnOver

function formatTurnOverArray(reportTurnOverByExecutive: ITurnOverTable, reportTurnOverByCompany: ITurnOverTable, reportTurnOverByArea: ITurnOverTable, reportTurnOverByUnit: ITurnOverTable) {
  FormatTableData.formatarTableData(reportTurnOverByExecutive)
  FormatTableData.formatarSubItens(reportTurnOverByExecutive)

  FormatTableData.formatarTableData(reportTurnOverByCompany)
  FormatTableData.formatarSubItens(reportTurnOverByCompany)

  FormatTableData.formatarTableData(reportTurnOverByArea)
  FormatTableData.formatarSubItens(reportTurnOverByArea)

  FormatTableData.formatarTableData(reportTurnOverByUnit)
  FormatTableData.formatarSubItens(reportTurnOverByUnit)

  reportTurnOverByExecutive.total = FormatTableData.mapTableDataItem(reportTurnOverByExecutive.total)
  reportTurnOverByCompany.total = FormatTableData.mapTableDataItem(reportTurnOverByCompany.total)
  reportTurnOverByArea.total = FormatTableData.mapTableDataItem(reportTurnOverByArea.total)
  reportTurnOverByUnit.total = FormatTableData.mapTableDataItem(reportTurnOverByUnit.total)
}

